<template>
  <el-menu
    :default-active="tabList[0].name"
    class="el-menu-vertical-demo"
    text-color="#212121"
    active-text-color="#00269A"
    @select="handleSelect"
  >
    <div v-for="(item,index) in tabList" :key="index">
      <template v-if="item.children.length > 0">
        <el-submenu :index="item.name">
          <template slot="title">
            <span>{{item.text}}</span>
          </template>
          <el-menu-item
            v-for="itemChild in item.children"
            :index="itemChild.name"
            :key="itemChild.name"
          >{{itemChild.text}}</el-menu-item>
        </el-submenu>
      </template>
      <template v-else>
        <el-menu-item :index="item.name" :key="item.name">{{item.text}}</el-menu-item>
      </template>
    </div>
  </el-menu>
</template>
<script>
export default {
  name: "slideTab",
  data() {
    return {};
  },
  props: {
    tabList: {
      default: []
    }
  },
  methods: {
    handleSelect(index) {
      this.$emit("selectKey", index);
    }
  }
};
</script>
<style lang="scss">
.page-wrap {
  color: #0f0f0f;
  .el-icon-arrow-down:before {
    color: #212121;
    font-weight: bold;
  }
  .el-col-18 {
    padding: 30px;
  }
  .el-col-17 {
    padding: 30px;
  }
  .el-col-4 {
    min-height: 100vh;
    border-right: 1px solid #e0e0e0;
    padding-top: 30px;
  }
  p {
    font-size: 16px;
    margin-bottom: 20px;
    line-height: 30px;
  }
  h6 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .el-menu {
    border: none;
    background: transparent;
    .el-menu-item {
      margin-bottom: 30px;
      font-size: 22px;
      font-weight: bold;
      span {
        font-size: 28px;
        font-weight: bold;
      }
      &:hover {
        background-color: transparent;
      }
    }
    .el-submenu {
      margin-bottom: 30px;
      .el-menu-item {
        font-size: 16px;
        height: inherit;
        line-height: normal;
        margin: 20px 0;
        text-decoration: none;
        color: #757575 !important;
        font-weight: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.is-active {
          background-color: transparent;
          color: #00269a !important;
        }
      }
      span {
        font-size: 22px;
        font-weight: bold;
      }
      .el-submenu__title {
        .el-submenu__icon-arrow {
          margin-left: 10px;
          right: inherit;
        }
        &:hover {
          background-color: transparent;
        }
      }
      &.is-active {
        .el-submenu__title {
          span {
            color: #00269a !important;
          }
        }
      }
    }
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #e0e0e0;
  }
  table tr td:first-child,
  table tr td:first-child {
    min-width: 120px;
  }
  table {
    margin: 20px 0;
    border-collapse: collapse;
    tr {
      line-height: 30px;
    }
  }
}
</style>
